"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function AcLink(props) {
    var text = props.text, to = props.to, icon = props.icon, hoverIcon = props.hoverIcon, extendProps = props.extendProps;
    function renderIcon() {
        if (!icon) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "double-icon" },
            react_1.default.createElement("i", { className: "link-icon is-normal", style: { backgroundImage: "url(".concat(icon, ")") } }),
            hoverIcon ? (react_1.default.createElement("i", { className: "link-icon is-hover", style: { backgroundImage: "url(".concat(hoverIcon, ")") } })) : null));
    }
    return (react_1.default.createElement("a", __assign({ className: "link-item", href: to, target: "_blank", rel: "noreferrer" }, (extendProps || {})),
        renderIcon(),
        react_1.default.createElement("span", { className: "link-text" }, text)));
}
exports.default = AcLink;
//# sourceMappingURL=AcLink.js.map